'use es6';

import { combineReducers } from 'redux';
import { ONBOARDING_DATA_POST, FETCH_ATTRIBUTES_META, RECEIVE_ATTRIBUTES_META } from 'DesignData/actions/ActionTypes';

function fetching(state = false, action) {
  switch (action.type) {
    case FETCH_ATTRIBUTES_META:
      {
        return true;
      }

    case RECEIVE_ATTRIBUTES_META:
      {
        return false;
      }

    default:
      {
        return state;
      }
  }
}

function fetchError(state = null, action) {
  switch (action.type) {
    case RECEIVE_ATTRIBUTES_META:
      {
        return action.error || null;
      }

    default:
      return state;
  }
}

function doneFetching(state = false, action) {
  switch (action.type) {
    case RECEIVE_ATTRIBUTES_META:
      {
        return true;
      }

    default:
      {
        return state;
      }
  }
}
/* Store true / false values for onboarding */


function createOnboardingReducer(property, initialState = true) {
  return (state = initialState, action) => {
    switch (action.type) {
      case RECEIVE_ATTRIBUTES_META:
        {
          const downgradeNotice = property === 'showStarterDowngradeNotice';
          const {
            onboardingSettings,
            userAttributes
          } = action;
          if (!userAttributes && !onboardingSettings) return state;

          if (onboardingSettings && onboardingSettings[property]) {
            return downgradeNotice ? onboardingSettings[property] || [] : !!onboardingSettings[property];
          }

          return downgradeNotice ? [] : false;
        }

      case ONBOARDING_DATA_POST:
        {
          const {
            attributes
          } = action;
          if (!attributes) return state;

          if (attributes && attributes[property] != null) {
            return attributes[property];
          }

          return state;
        }

      default:
        {
          return state;
        }
    }
  };
}

const hasUsedCos = createOnboardingReducer('hasUsedCos');
const hasOnboardedIDE = createOnboardingReducer('hasOnboardedIDE');
const hasSeenWelcomeTab = createOnboardingReducer('hasSeenWelcomeTab');
const hasSeenLocalDevAnnouncement = createOnboardingReducer('hasSeenLocalDevAnnouncement');
const showStarterDowngradeNotice = createOnboardingReducer('showStarterDowngradeNotice', []);
export default combineReducers({
  fetching,
  fetchError,
  hasUsedCos,
  hasOnboardedIDE,
  hasSeenWelcomeTab,
  hasSeenLocalDevAnnouncement,
  doneFetching,
  showStarterDowngradeNotice
});